import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
@Component
export class EventsList extends ThemeComponent {
    @Ref() showMoreTigger!: HTMLButtonElement;
    @Ref() hiddenEvents!: HTMLDivElement[];
    init() {
        this.showMoreTigger.addEventListener('click', () => {
            const firstTwoHiddenEvents = this.hiddenEvents.splice(0, 2);

            debugger; // eslint-disable-line no-debugger

            for (const firstTwoHiddenEvent of firstTwoHiddenEvents) {
                firstTwoHiddenEvent.classList.remove('visually-hidden');
            }

            if (this.hiddenEvents.length <= 2) {
                this.showMoreTigger.classList.add('visually-hidden');
            }
        });
    }
}
